import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { CustomModal } from "../../../Everou/_components/CustomModal";
import { CapsuleButton } from "../../../Common/_components";

type Props = {
    show: boolean;
    title: string;
    initialName: string;
    onCancel: () => void;
    onSubmit: (name: string) => void;
};

export function OrganizationFormModal({
    show,
    title,
    initialName,
    onCancel,
    onSubmit,
}: Props) {
    const { t } = useTranslation();
    const [name, setName] = useState(initialName);

    // Reset only when the modal opens: if initialName arrives late (detail
    // still loading) it must not overwrite what the user is typing.
    useEffect(() => {
        if (show) setName(initialName);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [show]);

    function handleSubmit() {
        const trimmed = name.trim();
        if (!trimmed) return;
        onSubmit(trimmed);
    }

    return (
        <CustomModal
            show={show}
            onHide={onCancel}
            title={title}
            content={
                <div className="d-flex flex-column">
                    <label className="font-weight-bold text-uppercase">
                        {t("mod_organizations_name")}
                    </label>
                    <input
                        type="text"
                        className="form-control"
                        value={name}
                        autoFocus
                        placeholder={t("mod_organizations_name_placeholder")}
                        onChange={(e) => setName(e.target.value)}
                        onKeyDown={(e) => {
                            if (e.key === "Enter") handleSubmit();
                        }}
                    />
                </div>
            }
            footer={
                <div className="d-flex">
                    <CapsuleButton
                        text={t("global_cancel")}
                        style={"INFO"}
                        onClick={onCancel}
                    />
                    <div className="ml-2" />
                    <CapsuleButton
                        text={t("global_save")}
                        onClick={handleSubmit}
                        isEnabled={!!name.trim()}
                    />
                </div>
            }
        />
    );
}
